export default {
  D_M_YYYY_HH_MM_SS: 'd-M-yyyy HH:mm:ss'
};
